import React, { useState, useEffect } from "react"
import { Flex, Box } from "@rebass/grid/emotion"

import { TextElementNova } from "@nutrafol/nutrafol-ui-kit/dist/TextElementNova"
import { segmentEvent } from "@nutrafol/nutrafol-ui-kit/utils/segmentfunctions"

import Section from "../section/section"

import PlusSmall from "../../../../../src/assets/icons/nova/plus-small.svg"
import Minus from "../../../../../src/assets/icons/nova/minus.svg"

import {
  AccordionWrapper,
  AccordionItem,
  AccordionControl,
} from "./index.styled"

const NovaFaqAccordion = ({ data }) => {
  const [openItem, setOpenItem] = useState(null)

  const handleToggle = (i, event, item) => {
    event.preventDefault()
    const isOpen = openItem === i
    setOpenItem(isOpen ? null : i)
    const eventName = isOpen ? "Section Collapsed" : "Section Expanded"
    segmentEvent(eventName, {
      section: item.question ? item.question : item.title,
      module_name: data.title ? data.title : data.heading || "FAQ",
    })
  }

  useEffect(() => {
    const quizLink = document.querySelectorAll(".quiz-link-external-faq")
    quizLink.forEach((link) => {
      link.addEventListener("click", (e) => {
        segmentEvent("Marketing CTA Clicked", {
          destination: "/quiz/",
          text: e?.target?.innerText,
          type: "link",
        })
      })
    })
  })

  const renderContent = (item, i) => {
    // reassign values if needed so this works for cms driven and data file driven
    return (
      <AccordionItem open={openItem === i} key={i}>
        <summary onClick={(event) => handleToggle(i, event, item)}>
          <Flex
            alignItems={`center`}
            justifyContent={`space-between`}
            className="flex"
          >
            <TextElementNova
              text={item.question ? item.question : item.title}
              element="h3"
              className="Body-20-Dia-Strong"
            />
            <AccordionControl className={openItem === i ? "opened" : "closed"}>
              {openItem === i ? <Minus /> : <PlusSmall />}
            </AccordionControl>
          </Flex>
        </summary>
        <TextElementNova
          text={item?.answer?.answer ? item.answer.answer : item.content}
          element="p"
          className="accordion__content Body-10-Dia-Normal"
        />
      </AccordionItem>
    )
  }

  return (
    <Section id={data.id || null}>
      <Flex
        flexwrap="wrap"
        flexDirection={["column", "column", "column", "row"]}
        className="flex-box gap-[32px] sm:gap-[40px]"
      >
        <Box width={[1, 1, 1, 1, 1 / 2]}>
          {data?.title ? (
            <TextElementNova
              text={data?.title}
              element="h2"
              className="Title-20-Super-Normal"
            />
          ) : (
            <>
              {data?.heading ? (
                <TextElementNova
                  text={data?.heading}
                  element="h2"
                  className="Title-20-Super-Normal"
                />
              ) : null}
            </>
          )}
        </Box>
        <Box width={[1, 1, 1, 1, 1 / 2]}>
          <AccordionWrapper>
            {/* if it matches the contentful data structure, or the data file structure, we handle both */}
            {data?.moduleReferences?.length > 0 ? (
              <>
                {data.moduleReferences.map((item, i) => renderContent(item, i))}
              </>
            ) : (
              <>{data.accordions.map((item, i) => renderContent(item, i))}</>
            )}
          </AccordionWrapper>
        </Box>
      </Flex>
    </Section>
  )
}
export default NovaFaqAccordion
